<template>
  <div class="verifyface">
    <!-- Loading状态 -->
    <section v-if="loading" class="loading-container">
      <z-loading type="zz" size="60px" vertical>正在加载</z-loading>
    </section>
    <!-- 主要内容 -->
    <template v-else>
     <z-fix-top
      keep-position
      class="fixtop"
    >
      <z-nav-bar
          v-show="status == 'commit'"
          class="navbar"
          left-arrow
          title="实人认证"
          :right-text="status == 'commit' && isZZ ? '更改认证方式' : ''"
          @click-left="closePage"
          @click-right="changeWay"
      >
      </z-nav-bar>
    </z-fix-top>
    <!-- 提交状态 -->
    <template v-if="status == 'commit'">
      <div class="commit-info">
        <!-- <z-notice-bar
          left-icon="volume-o"
          :scrollable="false"
          :text="yellowStripe"
        /> -->
        <div class="guide-title">
          {{ title }}
        </div>
        <div class="guide-info">{{content}}</div>
        <div v-if="!['0', '1'].includes(authType)" class="cardType">
          证件类型：{{cardType}}
        </div>
        <section v-if="['2','3'].includes(authType)" class="upload-area-single">
          <media-upload-item ocr :authType="authType" :cover="frontCover" :tip="frontTip" type="front" @uploaded="frontPicUploaded">
          </media-upload-item>
        </section>
        <z-field v-model="name" placeholder="请输入真实姓名" />
        <z-divider />
        <z-field
          :use-number-keyboard="['0', '1'].includes(authType)"
          v-model="idcard"
          placeholder="请输入证件号码"
          @focus="handleFocus"
          @blur="handleBlur"
        />
        <z-divider />
        <div class="agreement-list">
          <z-checkbox
            v-if="isZZ"
            v-model="agreementChecked.zz"
            :checked-color="isHeroClub ? '#111111' : ''"
          >
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="zzagreement">《实人认证服务协议》</span>
          </z-checkbox>

          <z-checkbox
            v-if="isZzqcidentity"
            v-model="agreementChecked.zzqc"
            :checked-color="isHeroClub ? '#111111' : ''"
          >
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="zzagreement">《实人认证服务协议》</span>
          </z-checkbox>

          <z-checkbox
            v-if="isSJJ"
            v-model="agreementChecked.sjj"
          >
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="sjjagreement">《实人认证服务协议》</span>
          </z-checkbox>

          <z-checkbox
            v-model="agreementChecked.privacy"
            :checked-color="isHeroClub ? '#111111' : ''"
          >
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="checkInfo">《个人信息处理授权书》</span>
          </z-checkbox>

          <z-checkbox
            v-if="isZLJ"
            v-model="agreementChecked.zlj"
            :checked-color="isHeroClub ? '#111111' : ''"
          >
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="zljagreement">《找靓机身份识别服务协议》</span>
          </z-checkbox>

          <z-checkbox
            v-if="isHeroClub"
            v-model="agreementChecked.heroclub"
            :checked-color="isHeroClub ? '#111111' : ''"
          >
            我已阅读并同意
            <span :style="{ color: '#42A0FF' }" @click.stop="heroclubagreement">《侠客汇身份识别服务协议》</span>
          </z-checkbox>
        </div>
        <z-button-group>
          <z-button type="primary" :disabled="!canSubmit" @click="submit" :style="isHeroClub ? heroClubButtonStyle : {}">开始验证</z-button>
        </z-button-group>
      </div>
    </template>

    <z-actionsheet
      title="更改认证方式"
      v-model="showModal"
      :actions="filteredActions"
      cancel-text="取消"
      @select="onSelect"
    />
    <!-- 仅在身份证或港澳台居住证时显示9宫格键盘 -->
    <z-number-keyboard
      v-if="['0', '1'].includes(authType)"
      close-on-click-overlay
      :show="showNumberKeyboard"
      extra-key="X"
      @input="onInput"
      @delete="onDelete"
    />

    <template v-if="status == 'recordface'">
      <div class="recordface">
        <div class="title">请确保本人操作</div>
        <!-- generated by ai -->
        <img :src="$setPicSize(headimg)" alt="">
        <div class="guide-info">根据法律法规和监管要求，为保障平台交易安全，需要收集您的人脸信息用于实人认证，{{ isSJJ ? '奢竞界' : (isZLJ ? '找靓机' : '转转') }}将保护您的个人信息安全。</div>
        <div class="buttonlist">
          <z-button @click="back">取消</z-button>
          <z-button type="primary" @click="startVerify" :style="isHeroClub ? heroClubButtonStyle : {}">开始扫脸</z-button>
        </div>
      </div>
    </template>
    </template>
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import { Query } from '@zz-biz/utils'
import { lego } from '@zz-common/lego'
import { NavBar, Button, ButtonGroup, FixTop, Field, Checkbox, Divider, NumberKeyboard, Actionsheet, Loading } from '@zz-common/zz-ui';
import { getsdkuserauthtext, getuserauthcardinfo, getCerRecognitionAndFaceStatus, presubmitBeforeFaceCer } from '@api/resourceApi'
// generated by ai
import { setPicSize } from '@zz-common/zz-utils'
import { queryParams, getCookie, curApp, compatibleHarmony, isHeroClubByUa } from '../../../lib/utils'
import MediaUploadItem from '../../RealAuthNew/MediaUploadItem/MediaUploadItem.vue'

const query = queryParams()

export default {
  name: 'CommitInfo',
  data() {
    // 获取Cookie中的t值判断是否为奢竞界APP
    const tValue = getCookie('t')
    const isSJJ = tValue === '243' || tValue === '244'
    return {
      // 协议选中状态
      agreementChecked: {
        zz: false, // 转转实人认证服务协议
        zzqc: false, // zzqcidentity实人认证服务协议
        privacy: false, // 个人信息处理授权书（必选）
        zlj: false, // 找靓机身份识别服务协议
        heroclub: false, // 侠客汇身份识别服务协议
        sjj: false // 奢竞界实人认证服务协议
      },
      name: '',
      idcard: '',
      picKeyFro: '',
      picKeyBack: '',
      //顶部文字
      yellowStripe: '认证成功后，实名不可更改。',
      content: '',
      title: '',
      headimg: require('./images/head.png'),
      sourcecode: query.sourcecode || this.$route.query.sourcecode,
      originsource: query.originsource || this.$route.query.originsource || '',
      strategyid: query.strategyid || this.$route.query.strategyid || '0',
      agreementNo: query.agreementNo || this.$route.query.agreementNo,
      authType: query.authType || this.$route.query.authType || '0', //认证方式
      status: 'commit',
      isZZ: native.in('zz'),
      isZLJ: native.in('zlj'),
      isZzqcidentity: native.in('zzqcidentity'),
      isSJJ, // 奢竞界APP
      loading: true, // 添加loading状态
      showNumberKeyboard: false,
      isHeroClub: isHeroClubByUa(),
      heroClubButtonStyle: {
        background: '#111111',
        color: '#F2D3A9',
        border: '1px solid #111111'
      },
      showModal: false,
      actions: [
        { name: '中华人民共和国居民身份证', value: '0' },
        { name: '中华人民共和国港澳台居民居住证', value: '1' },
        { name: '港澳居民来往内地通行证', value: '2' },
        { name: '台湾居民来往大陆通行证', value: '3' }
      ],
      frontCover1: require('@assets/img/id_card_front_sample_new.png'),
      frontCover2: require('@assets/img/id_card_entrance_new.png'),
      backCover1: require('@assets/img/id_card_back_sample_new.png'),
      backTip: '',
      frontTip: ''
    }
  },
  computed: {
    /**
     * 判断是否可以提交
     * 需要满足：
     * 1. 姓名和身份证号已填写
     * 2. 所有显示的协议都已勾选
     * 3. 如果是港澳通行证/台湾通行证，需要上传正面照片
     */
    canSubmit() {
      // 基础信息校验
      const hasBasicInfo = !!this.name && !!this.idcard
      // 协议勾选状态校验 - 所有应该显示的协议都必须勾选
      // 个人信息处理授权书是必选的
      const privacyChecked = this.agreementChecked.privacy
      // 转转实人认证服务协议（如果显示）
      const zzChecked = !this.isZZ || this.agreementChecked.zz
      // zzqcidentity实人认证服务协议（如果显示）
      const zzqcChecked = !this.isZzqcidentity || this.agreementChecked.zzqc
      // 找靓机身份识别服务协议（如果显示）
      const zljChecked = !this.isZLJ || this.agreementChecked.zlj
      // 侠客汇身份识别服务协议（如果显示）
      const heroclubChecked = !this.isHeroClub || this.agreementChecked.heroclub
      // 奢竞界实人认证服务协议（如果显示）
      const sjjChecked = !this.isSJJ || this.agreementChecked.sjj

      const allAgreementsChecked = privacyChecked && zzChecked && zzqcChecked && zljChecked && heroclubChecked && sjjChecked

      // 图片上传校验
      const hasPicture = (this.authType === '0' || this.authType === '1') || this.picKeyFro

      return hasBasicInfo && allAgreementsChecked && hasPicture
    },
    cardType() {
      return this.actions.find(t => t.value == this.authType)?.name || '-'
    },
    frontCover() {
      if (['0', '1'].includes(this.authType)) {
        return this.frontCover1
      } else {
        return this.frontCover2
      }
    },
    backCover() {
      return this.backCover1
    },
    filteredActions() {
      return this.actions.filter(action => action.value !== this.authType)
    }
  },
  components: {
    'z-nav-bar': NavBar,
    'z-fix-top': FixTop,
    'z-button': Button,
    'z-divider': Divider,
    'z-checkbox': Checkbox,
    'z-button-group': ButtonGroup,
    'z-field': Field,
    'z-number-keyboard': NumberKeyboard,
    'z-actionsheet': Actionsheet,
    'z-loading': Loading,
    MediaUploadItem
  },
  mounted() {
    native.wrap('setHeaderVisible')({
      visible: '0'
    })
    // 获取个人信息，判断认证状态
    if (native.in('zz') || this.isSJJ) {
      this.getAuthStatus()
    } else {
      // 非转转APP直接结束loading
      this.loading = false
    }
    //身份号认证获取页面文案信息
    getsdkuserauthtext({
      sourcecode: this.sourcecode
    })
      .then((res) => {
        this.content = res.content
        this.title = res.title
        this.yellowStripe = res.yellowStripe || this.yellowStripe
      })
      .catch((err) => {
        this.$toast(err)
      })

    if (this.agreementNo) {
      getuserauthcardinfo({
        agreementno: this.agreementNo,
        sourcecode: this.sourcecode
      })
        .then((res) => {
          this.idcard = res.userCardNo
          this.name = res.userName
        })
        .catch((err) => {
          console.error(err)
        })
    }

    lego.send({
      pagetype: 'auth_verifyface',
      actiontype: 'show',
      backup: {
        sourcecode: this.sourcecode,
        version: getCookie('v'),
        app: curApp()
      }
    })
  },
  methods: {
    // generated by ai
    $setPicSize(url) {
      return setPicSize(url)
    },
    /**
     * 获取认证状态，根据状态判断展示的认证类型
     */
    getAuthStatus() {
      const params = {
        uid: getCookie('uid'),
        sourceCode: this.sourcecode,
        strategyId: this.strategyid
      }
      getCerRecognitionAndFaceStatus(params)
        .then((res) => {
          const { selfFaceStatus, selfAuthStatus, selfCerRecStatus, selfName } = res
          // 实人或实名已认证的情况
          if (selfFaceStatus == '1' || selfAuthStatus == '1') {
            // strategyid=2或=3，有实人或实名，无港澳台流水时跳转face页面
            if (selfCerRecStatus == '1' || ((this.strategyid == '0' || this.strategyid == '1') && selfCerRecStatus == '0')) {
              // 根据是否为奢竞界APP判断sourcecode参数
              const facePageSourcecode = this.isSJJ ? 'c2p_add_face_page' : 'add_face_page'
              native.skipToUrl({
                targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/privateinfosupply/face?name=${encodeURI(selfName)}&sourcecode=${facePageSourcecode}&strategyid=${this.strategyid}`,
                needClose: '1'
              })
              return
            }
            // 判断是否需要跳转到证件补充页面
            if ((this.strategyid == '2' || this.strategyid == '3') && selfCerRecStatus == '0') {
              native.skipToUrl({
                targetUrl: `https://m.zhuanzhuan.com/platform/zz-universal-pages/index.html#/privateinfosupply/hkmtface?sourcecode=${this.sourcecode}&authType=${this.strategyid}&name=${encodeURI(this.name)}&result=false&strategyid=${this.strategyid}`,
                needClose: '1'
              })
            }
          } else if (selfFaceStatus == '0' && selfAuthStatus == '0') {
            // 如果实人未认证且实名未认证，根据strategyid展示对应认证类型
            this.setAuthTypeByStrategy()
          }
        })
        .catch((err) => {
          console.error('获取认证状态失败:', err)
          // 接口失败时使用原有逻辑
          this.setAuthTypeByStrategy()
        })
        .finally(() => {
          // 无论成功还是失败都结束loading
          this.loading = false
        })
    },
    /**
     * 根据strategyid设置认证类型
     */
    setAuthTypeByStrategy() {
      // strategyid 在指定范围内时，authType 和 strategyid 值一致
      if (this.strategyid && ['0', '1', '2', '3'].includes(this.strategyid)) {
        this.authType = this.strategyid
      } else {
        // strategyid 不在范围内时，默认展示身份证认证页面（authType = '0'）
        this.authType = '0'
      }
    },
    frontPicUploaded(rst, ocr = '') {
      lego.send({
        pagetype: 'auth_verifyface',
        actiontype: 'front_pic',
        backup: {
          sourcecode: this.sourcecode,
          version: getCookie('v'),
          app: curApp(),
          authType: this.authType,
          originsource: this.originsource
        }
      })
      this.picKeyFro = rst
      if (ocr && !this.name && !this.idcard) {
        this.name = ocr.name
        this.idcard = ocr.cardId
      }
    },
    backPicUploaded(rst, _ocr = '') {
      lego.send({
        pagetype: 'auth_verifyface',
        actiontype: 'back_pic',
        backup: {
          sourcecode: this.sourcecode,
          version: getCookie('v'),
          app: curApp(),
          authType: this.authType,
          originsource: this.originsource
        }
      })
      this.picKeyBack = rst
    },
    changeWay() {
      // 只在转转APP中允许更改认证方式
      if (!native.in('zz') || this.status !== 'commit') return
      this.showModal = true
    },
    onSelect(val) {
      this.showModal = !this.showModal
      // 直接改变当前页面的认证方式
      this.authType = val.value
      this.strategyid = val.value
    },
    zzagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/67e371c0da1f4e0062fc0d97/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    zljagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401c5d7c955420077193c75/index.html?magicplatform=zlj&needNewWebview=1',
        needClose: '0'
      })
    },
    checkInfo() {
      let targetUrl = 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401a9e6447e27006914ecb0/index.html?magicplatform=common&needNewWebview=1'

      if (this.isHeroClub) {
        targetUrl = 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6698f702c68048006a695502/index.html?magicplatform=zz&needNewWebview=1'
      } else if (this.isSJJ) {
        targetUrl = 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6401a9e6447e27006914ecb0/index.html?magicplatform=common&needNewWebview=1'
      }

      native.skipToUrl({
        targetUrl,
        needClose: '0'
      })
    },
    heroclubagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/6698f7760bf2ed006a040567/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    sjjagreement() {
      native.skipToUrl({
        targetUrl: 'https://m.zhuanzhuan.com/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/691c3375ee471600647e64f8/index.html?magicplatform=zz&needNewWebview=1',
        needClose: '0'
      })
    },
    isUserNameValid() {
      const regName = /^[\u2e80-\u9fff]+(·[\u2e80-\u9fff]+)*$/
      return regName.test(this.name)
    },
    isIDCardValid() {
      // 只有authType为0（身份证）时才校验格式，其他类型只校验长度不超过18
      if (this.authType === '0') {
        const regIdNo = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        return regIdNo.test(this.idcard)
      } else {
        // 其他证件类型只校验长度不超过18位
        return this.idcard.length <= 18 && this.idcard.length > 0
      }
    },
    submit() {
      if (!this.isUserNameValid()) {
        this.$toast('姓名错误，请填写中文')
        return
      }
      if (!this.isIDCardValid()) {
        if (this.authType === '0') {
          this.$toast('身份证号错误，请填写 18 位数字和字母')
        } else {
          this.$toast('证件号码错误，请填写不超过18位的证件号码')
        }
        return
      }

      // 只在转转APP中调用presubmitBeforeFaceCer接口
      if (native.in('zz') && ['2', '3'].includes(this.authType)) {
        const params = {
          uid: this.$store?.state?.userInfo?.uid || '',
          sourceCode: this.sourcecode,
          type: this.authType,
          picKeyFro: this.picKeyFro || '',
          picKeyBack: this.picKeyBack || '',
          name: this.name,
          cardId: this.idcard
        }
        console.log('params', params)
        presubmitBeforeFaceCer(params)
          .then((res) => {
            if (res.code === 0) {
              // 接口调用成功，进入扫脸页面
              this.status = 'recordface'
            } else {
              // 接口调用失败
              this.$toast(res?.message || '提交失败，请重试')
            }
          })
          .catch((err) => {
            console.error('接口调用失败:', err)
            this.$toast('提交失败，请重试')
          })
      } else {
        // 身份证直接进入扫脸页面，或非转转APP的情况
        this.status = 'recordface'
      }
    },
    closePage() {
      native.close()
    },
    /**
     * 处理输入框聚焦事件
     * 只有在身份证或港澳台居住证时才显示自定义键盘
     */
    handleFocus() {
      if (['0', '1'].includes(this.authType)) {
        this.showNumberKeyboard = true
      }
    },
    /**
     * 处理输入框失焦事件
     */
    handleBlur() {
      if (['0', '1'].includes(this.authType)) {
        this.showNumberKeyboard = false
      }
    },
    onInput(value) {
      this.idcard += value;
    },
    onDelete() {
      this.idcard = this.idcard.slice(0, -1);
    },
    back() {
      this.status = 'commit'
    },
    startVerify() {
      lego.send({
        pagetype: 'auth_verifyface',
        actiontype: 'submit',
        backup: {
          sourcecode: this.sourcecode,
          version: getCookie('v'),
          app: curApp()
        }
      })
      if (compatibleHarmony()) return;
      if (native.in('zz') || native.in('zzqcidentity') || this.isHeroClub || this.isSJJ) {
        console.log('this.strategyid', this.strategyid)
        native.wrap('startFaceVerify')(
          {
            name: this.name,
            cardId: this.idcard,
            sourceCode: this.sourcecode,
            isShowPrivacyPage: '0',
            strategyId: this.strategyid
          },
          (res) => {
            if (res.code == '0') {
              lego.send({
                pagetype: 'auth_verifyface',
                actiontype: 'success',
                backup: {
                  sourcecode: this.sourcecode,
                  version: getCookie('v'),
                  app: native.in('zz') ? 'zz' : 'zzqcidentity'
                }
              })
              if (res.jumpUrl) {
                //兼容大师熊头部箭头出现两个问题
                if (native.in('zzqcidentity')) {
                  native.skipToUrl({
                    targetUrl: Query.add({ sourcecode: this.sourcecode, needHideHead: 3 }, res.jumpUrl),
                    needClose: '1'
                  })
                } else {
                  native.skipToUrl({
                    targetUrl: Query.add({ sourcecode: this.sourcecode }, res.jumpUrl),
                    needClose: '1'
                  })
                }
              } else {
                this.$router.replace({
                  path: '/realauth/verifyface/result',
                  query: {
                    sourcecode: this.sourcecode,
                    agreementNo: res.agreementNo,
                    strategyid: this.strategyid
                  }
                })
              }
            }
            if (res.code == '-1') {
              this.status = 'commit'
              lego.send({
                pagetype: 'auth_verifyface',
                actiontype: 'fail',
                backup: {
                  sourcecode: this.sourcecode,
                  version: getCookie('v'),
                  app: native.in('zz') ? 'zz' : 'zzqcidentity'
                }
              })
            }
          }
        )
      }
      if (native.in('zlj')) {
        native.wrap('faceRecognitionOcr')({
          source_code: this.sourcecode,
          card_name: this.name,
          card_no: this.idcard
        },
        (res) => {
          this.res = JSON.stringify(res);
          const { statusCode, statusText, data: { agreementNo } = {} } = res;
          if (statusCode && agreementNo) {
            this.$router.replace({
              path: '/realauth/verifyface/result',
              query: {
                sourcecode: this.sourcecode,
                agreementNo,
                strategyid: this.strategyid
              }
            })
          } else if (statusCode && statusText) {
            this.$toast(statusText)
          }
        }
        )
      }
    }
  },
  watch: {
    name: function(newval, _oldval) {
      this.name = newval.replace(/\./g, '·')
    },
    authType: function(_newval, _oldval) {
      this.picKeyBack = ''
      this.picKeyFro = ''
      this.name = ''
      this.idcard = ''
    }
  }
}
</script>

<style lang="less" scoped>
  @import 'index.less';
</style>
